import { render } from "./MiniInfoCard.vue?vue&type=template&id=cd295bba"
import script from "./MiniInfoCard.vue?vue&type=script&lang=js"
export * from "./MiniInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__